import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router, RouterModule, RouterOutlet } from '@angular/router';
import { AuthRightComponent } from '../../core/common_components/auth-right/auth-right.component';
import { assets } from '../../core/constants/assets.const';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'mindbase-auth',
  standalone: true,
  imports: [RouterOutlet, CommonModule, AuthRightComponent, RouterModule, MatSelectModule, TranslateModule, FormsModule],
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.scss'
})
export class AuthComponent implements OnInit {

  protected assetsConst = assets;
  protected webLogo: any;
  protected selectedLanguage: string | null = null;
  route = inject(ActivatedRoute);
  router = inject(Router);
  public isIFrame: boolean = false;
  constructor(@Inject(PLATFORM_ID) private platformId: object,  private _translateService: TranslateService,   private _commonService: CommonService, private cdr: ChangeDetectorRef) {
    this.route.queryParams.subscribe(params => {
      this.isIFrame = params['isIFrame'] === 'true';
    });    
    this.selectedLanguage = localStorage.getItem(environment.langKey) ? localStorage.getItem(environment.langKey) : 'en';
  }

  ngOnInit(): void {
    this.webLogo = this.getWebSettings()?.webLogo || this.assetsConst.mainLogo;
    setTimeout(() => {
      const updatedLogo = this.getWebSettings()?.webLogo;
      if (updatedLogo) {
        this.webLogo = updatedLogo;
        this.cdr.detectChanges();
      }
    }, 500); 
  }

  protected loginRoute():void {
    if (!this.isIFrame) {
      this.router.navigateByUrl('/auth/login');
    }
  } 

  getWebSettings(): any {
    const val = localStorage.getItem('webSettings');
    if (!val || val === 'undefined') return {};
    try {
      return JSON.parse(val);
    } catch {
      return {};
    }
  }

  onLanguageChange(lang: 'en' | 'ar'): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(environment.langKey, lang);
    }
    this.selectedLanguage = lang;
    this._commonService.selectedLanguage.next(lang);
    this._translateService.setDefaultLang(lang);
  }
}
